import React, { useEffect } from "react";
import { AssetInterface } from "../../../../store/sticker_maker/assetsSlice";

import {Button, Form, Select} from "antd";
import FileDropzone from "../../../../componets/FileDropzone";
import { filterOptionByLabel } from "../../../../helpers/FormHelper";
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "../../../../store/hooks";
import { selectCategoryEntities, selectCategoryIds } from "../../../../store/sticker_maker/categoriesSlice";
import { AVAILABLE_FONTS } from "../../../../configs/constants";

interface propsInterface {
  params?: AssetInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const categories = useAppSelector(selectCategoryEntities);
  const categoryIds = useAppSelector(selectCategoryIds);
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const fontOptions: any = [];

  Object.keys(AVAILABLE_FONTS).forEach((groupName) => {
    const fontOption: any = { label: groupName, options: [] };

    AVAILABLE_FONTS[groupName].forEach((font) => {
      fontOption.options.push({ label: font, value: font });
    });

    fontOptions.push(fontOption);
  });

  const renderCategoryOption = (id: EntityId) => {
    const item = categories[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.name}>{item.name}</Select.Option>
  }

  const renderCategories = () => {
    if (params?.target !== 0) {
      return null;
    }

    return (
      <Form.Item
        name='category_id'
        label="Select a category"
      >
        <Select
          allowClear
          showSearch
          filterOption={filterOptionByLabel}
          placeholder='Select a category'
        >
          {categories && categoryIds.map(renderCategoryOption)}
        </Select>
      </Form.Item>
    )
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='item' label='Asset' preview={params?.item_url} />
      </div>

      {renderCategories()}

      <Form.Item
        name='font_name'
        label="Select a font"
      >
        <Select
          allowClear
          showSearch
          filterOption={filterOptionByLabel}
          placeholder='Select a font'
          options={fontOptions}
        />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
